import React, { forwardRef } from "react";
import { BoxProps } from "@mui/material/Box";
import MDBoxRoot from "./MDBoxRoot";
import { MDBoxProps } from "./types";

const MDBox = forwardRef<HTMLDivElement, MDBoxProps & BoxProps>(
  (
    {
      variant = "contained",
      bgColor = "transparent",
      color = "dark",
      opacity = 1,
      borderRadius = "none",
      shadow = "none",
      coloredShadow = "none",
      children,
      ...rest
    },
    ref
  ) => (
    <MDBoxRoot
      {...rest}
      ref={ref}
      ownerState={{
        variant,
        bgColor,
        color,
        opacity,
        borderRadius,
        shadow,
        coloredShadow,
      }}
    >
      {children}
    </MDBoxRoot>
  )
);

MDBox.displayName = "MDBox";

export default MDBox;